export const screenSize = {
	sm: '@media all and (max-width: 910px) and (max-resolution: 4dppx), all and (max-width: 910px) and (-webkit-max-device-pixel-ratio: 4)',
	ms: '@media all and (max-width: 1070px) and (max-resolution: 4dppx), all and (max-width: 1070px) and (-webkit-max-device-pixel-ratio: 4)',
	md: '@media all and (max-width: 1250px) and (max-resolution: 4dppx), all and (max-width: 1250px) and (-webkit-max-device-pixel-ratio: 4)',
};
